export const authPaths = {
  login: "/login",
};
export const appPaths = {
  home: "/",
  definition: "/definition",
  preparation: "/preparation",
};
